import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    @font-face {
        font-family: 'Nunito Sans';
        font-style: normal;
        font-weight: 400;
        src: local(''),
        url('/static/fonts/nunito-sans-v12-latin-ext_latin-regular.woff2') format('woff2'),
        url('/static/fonts/nunito-sans-v12-latin-ext_latin-regular.woff') format('woff');
    }
    @font-face {
        font-family: 'Nunito Sans';
        font-style: normal;
        font-weight: 700;
        src: local(''),
        url('/static/fonts/nunito-sans-v12-latin-ext_latin-600.woff2') format('woff2'),
        url('/static/fonts/nunito-sans-v12-latin-ext_latin-600.woff') format('woff');
    }
    @font-face {
        font-family: 'Nunito Sans';
        font-style: normal;
        font-weight: 700;
        src: local(''),
        url('/static/fonts/nunito-sans-v12-latin-ext_latin-700.woff2') format('woff2'),
        url('/static/fonts/nunito-sans-v12-latin-ext_latin-700.woff') format('woff');
    }

    position: relative;
    width: 100%;
    padding: 2em 0;

    .layout-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 1em;
    }

    .wrapper-side {
        position: sticky;
        top: 140px;
    }

    .wrapper-article {
        width: 100%;
        margin-top: 1em;

        .article-content {
            .article-content-list {
                padding: 1.4em 2em;
                background-color: #F2F2F2;
                border-radius: 10px;

                .list-headline {
                    font-family: 'Nunito Sans', sans-serif !important;
                    font-size: 28px;
                    font-weight: 700;
                    margin-bottom: 0.6em;
                    color: rgb(178, 144, 81);
                }
            }

            .public-layout-offer-box-offer,
            .public-layout-offer-box-product {
                margin-top: 3em;
                max-width: 360px;

                .offer-content {
                    .checkbox-add-max {
                        font-size: 0.85em;
                    }

                    .checkbox-add-max-info {
                        .layout-tooltip {
                            .type-dark {
                                background-color: #444444;
                                color: #ffffff
                            }
                        }
                    }

                    .pricing-controls {
                        font-size: 0.8em;
                    }

                    .price-info {
                        font-size: 0.7em;

                        &__bigger {
                            font-size: 1.3em;
                        }
                    }
                }
            }

            .public-layout-section-contact {
                margin-top: 5em;
            }

            .public-layout-section-contact-single-form {
                margin-top: 3em;

                .layout-container {
                    margin: 0;

                    .form-container {
                        width: 100%;
                        max-width: 460px;
                    }
                }
            }
        }
    }

    .wrapper-side {
        position: sticky;
        top: 132px;
    }


    @media all and (max-width: ${variables.tabletS}) {
        .layout-container {
            flex-direction: column;
        }

        .wrapper-article {
            width: 100%;
        }

        .wrapper-side {
            display: none;
        }
    }

    @media all and (max-width: ${variables.mobileL}) {
        padding: 0;

        .wrapper-article {
            .article-content {
                .public-layout-section-contact {
                    margin-top: 2em;
                }
            }
        }

        .content {
            .layout-html-styled-content {
                p {
                    font-size: 1.3em !important;
                }
            }
        }
    }
`;
